import React, {Component} from 'react';
import Helmet from 'react-helmet';

import DefaultLayout from '../Layout/DefaultLayout.jsx';
import {ImageHeader, ImageHeaderTitle, ImageHeaderBrief} from '../../components/ImageHeader/ImageHeader.jsx';
import TimelineSource from '../../components/Timeline/Timeline.jsx';
import TimelineElement from '../../components/Timeline/TimelineElement.jsx';

import conf from '../../conf.js';

import logoDecisionAchats from './images/logo-decisions-achat.png';
import logoLettreDesAchats from './images/logo-lettre-des-achats.png';
import logoUsineNouvelle from './images/logo-usine-nouvelle.svg';
import logoBFM from './images/bfm.svg';
import logoInfoEntreprises from './images/logo-info-entreprises.svg';
import logoChallenges from './images/logo-challenges.svg';

import './Press.scss';

const title = "Ils parlent de nous";
const description = "Tous les articles de presse mentionnant Twineeds";

export default class Press extends Component {
  render() {
    const helmet = <Helmet>
      <title>{title}</title>
      <meta name="description" content={description}/>
      <meta property="og:description" content={description}/>
      <meta property="og:title" content={title}/>
    </Helmet>;

    return (
      <DefaultLayout showSidebarMenu={false} className="press" helmet={helmet}>
        <ImageHeader>
          <ImageHeaderTitle>
            <h1>Ils parlent de nous</h1>
          </ImageHeaderTitle>
          <ImageHeaderBrief>
            Retrouvez toutes les actualités de Twineeds
          </ImageHeaderBrief>
        </ImageHeader>
        <div className="container">
          <TimelineSource className="mt-5">
            <TimelineElement
              tickPosition="right"
              className="col-lg-6 d-flex flex-column flex-sm-row flex-lg-row-reverse"
            >
              <p className="publication-date pl-3 px-md-3">09/2022</p>
              <div className="timeline-content pl-3 pl-sm-0 mb-5">
                <img src={logoChallenges} className="my-2" alt="Challenges"/>
                <h6>Twineeds : Les entreprises doivent diversifier leurs compétences</h6>
                <p className="brief">
                  "Grande Démission", pénuries de compétences, le monde du travail est en pleine mutation. Le point
                  avec Pierre Langlois, Responsable de la croissance de Twineeds, spécialiste sur les métiers
                  corporatifs (Achats, RH et Finance).
                </p>
                <a
                  href="https://www.challenges.fr/entreprise/la-voix-des-dirigeants/twineeds-les-entreprises-doivent-diversifier-leurs-competences_828616"
                  className="btn btn-primary" target="_blank" rel="noopener noreferrer">
                  Lire l'article
                </a>
              </div>
            </TimelineElement>
            <TimelineElement
              tickPosition="left"
              className="offset-lg-6 col-lg-6 d-flex flex-column flex-md-row"
            >
              <p className="publication-date pl-3 px-md-3">02/2021</p>
              <div className="timeline-content pl-3 pl-sm-0 mb-5">
                <img src={logoInfoEntreprises} className="my-2" alt="Logo l'Usine Nouvelle"/>
                <h6>
                  De la marketplace au deepmatching, paru dans Informations Entreprise N° 177 (1er trimestre 2021)
                </h6>
                <p className="brief">
                  En 10 ans, deux phénomènes majeurs ont impacté durablement le fonctionnement des organisations
                  "Corporate". L'agilité, car les grandes entreprises doivent s'adapter en permanence, notamment face
                  à des acteurs émergents innovants. La qualité où les profils à haute valeur ajoutée ont des
                  exigences et recherchent des expériences apprenantes et qualifiantes.
                </p>
                <a
                  href="https://fr.calameo.com/read/005804111334cd234af56"
                  className="btn btn-primary" target="_blank" rel="noopener noreferrer">
                  Lire l'article
                </a>
              </div>
            </TimelineElement>
            <TimelineElement
              tickPosition="right"
              className="col-lg-6 d-flex flex-column flex-sm-row flex-lg-row-reverse"
            >
              <p className="publication-date pl-3 px-md-3">12/2019</p>
              <div className="timeline-content pl-3 pl-sm-0 mb-5">
                <img src={logoUsineNouvelle} className="my-2" alt="Logo l'Usine Nouvelle"/>
                <h6>Twineeds, le boom du Conseil Achat</h6>
                <p className="brief">
                  Créée en novembre 2017, Twineeds a le vent en poupe. Son originalité porte sur sa capacité à dénicher
                  des consultants ultra-spécialisés Achats et Supply.
                </p>
                <a
                  href="https://www.usinenouvelle.com/article/notre-selection-d-acteurs-en-achats-et-reduction-des-couts-reconnus-pour-leur-expertise.N915019"
                  className="btn btn-primary" target="_blank" rel="noopener noreferrer">
                  Lire l'article
                </a>
              </div>
            </TimelineElement>
            <TimelineElement
              tickPosition="left"
              className="offset-lg-6 col-lg-6 d-flex flex-column flex-md-row"
            >
              <p className="publication-date pl-3 px-md-3">12/2019</p>
              <div className="timeline-content pl-3 pl-sm-0 mb-5">
                <img src={logoUsineNouvelle} className="my-2" alt="Logo l'Usine Nouvelle"/>
                <h6>Twineeds : à chaque coût son spécialiste, toutes les expertises Achat sur une plateforme</h6>
                <p className="brief">
                  Dans un contexte de réduction des coûts, Twineeds se démarque par sa capacité à trouver
                  des spécialistes achats de tous les domaines. Twineeds fournit ainsi les meilleurs experts qui
                  maîtrisent parfaitement les pratiques de tous les fournisseurs.
                </p>
                <a
                  href="https://www.usinenouvelle.com/article/twineeds-a-chaque-cout-son-specialiste-toutes-les-expertises-achat-sur-une-plateforme.N913199"
                  className="btn btn-primary" target="_blank" rel="noopener noreferrer">
                  Lire l'article
                </a>
              </div>
            </TimelineElement>
            <TimelineElement
              tickPosition="right"
              className="col-lg-6 d-flex flex-column flex-sm-row flex-lg-row-reverse"
            >
              <p className="publication-date pl-3 px-md-3">06/2019</p>
              <div className="timeline-content pl-3 pl-sm-0 mb-5">
                <img src={logoDecisionAchats} className="my-2" alt="Logo Décisions-Achats.fr"/>
                <h6>Twineeds : la marketplace de l'expertise achats</h6>
                <p className="brief">
                  Recourir à des consultants achats en freelance est gage de flexibilité. C’est aussi une capacité
                  pour l’entreprise de trouver des ressources rares. C’est ce que propose la marketplace Twineeds
                  avec des profils allant de l’opérationnel au manager de transition en Achats et Supply Chain.
                  Rencontre avec les créateurs du projet.
                </p>
                <a href={conf.downloadableFiles.pressFile}
                  className="btn btn-primary" target="_blank" rel="noopener noreferrer">
                  Lire l'article
                </a>
              </div>
            </TimelineElement>
            <TimelineElement
              tickPosition="left"
              className="offset-lg-6 col-lg-6 d-flex flex-column flex-md-row"
            >
              <p className="publication-date pl-3 px-md-3">04/2019</p>
              <div className="timeline-content pl-3 pl-sm-0 mb-5">
                <img src={logoLettreDesAchats} className="my-2" alt="Logo la Lettre des Achats"/>
                <h6>Le plébiscite des marketplaces spécialisées</h6>
                <p className="brief">
                  Synonymes de sourcing simpli é, de mise en concurrence facilitée ou d’achats
                  groupés, les marketplaces ou places de marché, sont en pleine expansion dans le
                  B2B. Accor Hôtels, Alstom, Suez ou encore Siemens... ont déjà franchi le pas. Mais
                  en dépit d’une expérience utilisateur B2C favorisant leur adoption, bâtir sa propre
                  marketplace reste un projet technologique complexe (version abonnés).
                </p>
                <a
                  href="https://www.lettredesachats.com/services/revue/e-docs/e_commerce_le_plebiscite_des_marketplaces_specialisees_25858/document_dossier.phtml"
                  className="btn btn-primary" target="_blank" rel="noopener noreferrer">
                  Lire l'article
                </a>
              </div>
            </TimelineElement>
            <TimelineElement
              tickPosition="right"
              className="col-lg-6 d-flex flex-column flex-sm-row flex-lg-row-reverse"
            >
              <p className="publication-date pl-3 px-md-3">10/2018</p>
              <div className="timeline-content pl-3 pl-sm-0 mb-5">
                <img src={logoDecisionAchats} className="my-2" alt="Logo Décisions-Achats.fr"/>
                <h6>Avoir recours aux acheteurs indépendants, pourquoi, comment ?</h6>
                <p className="brief">
                  Quand l'intérim cadre est lacunaire, l'acheteur indépendant est capable de répondre à un besoin
                  opérationnel ponctuel pointu mais sans les fioritures d'un cabinet conseil.
                  Attention toutefois à bien cadrer la relation avec ces électrons libres.
                </p>
                <a
                  href="https://www.decision-achats.fr/Thematique/strategie-achats-1236/Breves/Avoir-recours-acheteurs-independants-pourquoi-comment-334356.htm"
                  className="btn btn-primary" target="_blank" rel="noopener noreferrer">
                  Lire l'article
                </a>
              </div>
            </TimelineElement>
            <TimelineElement
              tickPosition="left"
              className="offset-lg-6 col-lg-6 d-flex flex-column flex-md-row"
            >
              <p className="publication-date pl-3 px-md-3">09/2018</p>
              <div className="timeline-content pl-3 pl-sm-0 mb-5">
                <img src={logoDecisionAchats} className="my-2" alt="Logo Décisions-Achats.fr"/>
                <h6>Twineeds met les consultants achats indépendants en vitrine</h6>
                <p className="brief">
                  L'écosystème des achats s'est enrichi d'une plateforme de mise en relation entre donneurs d'ordres et
                  consultants freelance spécialisés en achats et en supply.
                  Une information qui intéressera autant les donneurs d'ordre que les consultants.
                </p>
                <a
                  href="https://www.decision-achats.fr/Thematique/rh-1234/Breves/Twineed-met-consultants-achats-independants-vitrine-333871.htm"
                  className="btn btn-primary" target="_blank" rel="noopener noreferrer">
                  Lire l'article
                </a>
              </div>
            </TimelineElement>
            <TimelineElement
              tickPosition="right"
              className="col-lg-6 d-flex flex-column flex-sm-row flex-lg-row-reverse"
            >
              <p className="publication-date pl-3 px-md-3">05/2018</p>
              <div className="timeline-content pl-3 pl-sm-0 mb-5">
                <img src={logoLettreDesAchats} className="my-2" alt="Logo la Lettre des Achats"/>
                <h6>Les acheteurs indépendants ont leur place de marché</h6>
                <p className="brief">
                  Twineeds est la toute nouvelle plateforme – lancée en février – qui met en relation
                  acheteurs indépendants et directions achats. Trente profils sont inscrits. Objectif
                  cent fin 2018 (version abonnés).
                </p>
                <a
                  href="https://www.lettredesachats.com/services/revue/e-docs/les_acheteurs_independants_ont_leur_place_de_marche_25260/document_article.phtml"
                  className="btn btn-primary" target="_blank" rel="noopener noreferrer">
                  Lire l'article
                </a>
              </div>
            </TimelineElement>
            <TimelineElement
              tickPosition="left"
              className="offset-lg-6 col-lg-6 d-flex flex-column flex-md-row"
            >
              <p className="publication-date pl-3 px-md-3">02/2018</p>
              <div className="timeline-content pl-3 pl-sm-0 mb-5">
                <img src={logoBFM} className="my-2" alt="Logo BTFM TV"/>
                <h6>PME Stories: Interview d'Eric Betton</h6>
                <p className="brief">
                  <iframe title="Interview d'Eric Betton (BFM TV)" frameBorder="0" width="480" height="270"
                    src="https://www.dailymotion.com/embed/video/x6r8orw" allowFullScreen/>
                </p>
              </div>
            </TimelineElement>
          </TimelineSource>
        </div>
      </DefaultLayout>
    );
  }
}